import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "invalid-feedback d-block field-errors mb-0"
}


export default {
  __name: 'FieldErrors',
  props: {
	errors: { type: Array, default: () => [] },
},
  setup(__props) {



return (_ctx, _cache) => {
  return (__props.errors.length)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.errors, (message, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(message), 1 /* TEXT */))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}
}

}